import { Component, Input, Output, EventEmitter } from "@angular/core";
import { EmbargoManagementPageDataService } from "../embargo-management-page-data.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { saveAs } from "file-saver";

@Component({
  selector: "app-embargo-export-modal",
  templateUrl: "./embargo-export-modal.component.html",
  styleUrls: ["./embargo-export-modal.component.scss"],
})
export class EmbargoExportModalComponent {
  fileTypes = [
    {
      label: "csv",
      value: "csv",
    },
    {
      label: "xlsx",
      value: "xlsx",
    },
  ];

  selectedFileType = "csv";

  @Input() showModal: boolean;
  @Input() brokerSearchKeyword;
  @Input() buySideSearchKeyword;
  @Input() sortOrder;
  @Input() sortBy;
  @Output() closeModal = new EventEmitter();

  constructor(
    private dataService: EmbargoManagementPageDataService,
    private message: NzMessageService,
  ) {}

  handleCancelForExportEmbargo() {
    this.closeModal.emit(false);
  }

  export() {
    const jsonData = {
      report_params: {
        broker_keyword: this.brokerSearchKeyword
          ? encodeURIComponent(this.brokerSearchKeyword)
          : "",
        buyside_keyword: this.buySideSearchKeyword
          ? encodeURIComponent(this.buySideSearchKeyword)
          : "",
        sortby: this.sortBy,
        sortorder: this.sortOrder,
      },
      report_type: "EmbargoOverrides",
      report_format: this.selectedFileType,
    };

    this.dataService.exportEmbargo(jsonData).subscribe(
      (data) => {
        if (data.headers.get("content-disposition") !== null) {
          const fileName = data.headers
            .get("content-disposition")
            .split("=")[1];

          if (this.selectedFileType === "csv") {
            const blob = new Blob([data.body], {
              type: "text/csv;charset=utf-8",
            });
            saveAs(blob, fileName);
          } else {
            saveAs(data.body, fileName);
          }
        }
      },
      (err) => {
        this.message.create("error", `${err["error"]["errors"]}`);
      },
    );
  }
}
